import { SubmissionStatus } from '../types/submission';

/**
 * Map of uppercase status keys to their display values.
 * Used for consistent submission status lookups across the application.
 */
export const SUBMISSION_STATUSES: Record<string, SubmissionStatus> = Object.freeze({
  REVIEW: 'Review',
  APPROVAL: 'Approval',
  APPROVED: 'Approved',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected',
} as const);
